import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { PersonalAccountState } from './types';

export const initialState: PersonalAccountState = {
  userEndpointToken: undefined,
  workerToken: undefined,
};

export const personalAccountSlice = createSlice({
  name: 'personalAccount',
  initialState,
  reducers: {
    setUserEndpointToken: (
      state,
      action: PayloadAction<PersonalAccountState['userEndpointToken']>,
    ) => {
      state.userEndpointToken = action.payload;
    },
    setWorkerToken: (
      state,
      action: PayloadAction<PersonalAccountState['workerToken']>,
    ) => {
      state.workerToken = action.payload;
    },
    resetPersonalAccountSlice: () => initialState,
  },
});

export const {
  resetPersonalAccountSlice,
  setUserEndpointToken,
  setWorkerToken,
} = personalAccountSlice.actions;
